import { connect } from 'dva'

import scoreSelector from 'models/score/selectors'

import Score from './Score'

function mapStateToProps(state, ownProps) {
  return Object.assign({},
    scoreSelector(state, ownProps),
  )
}

export default connect(mapStateToProps)(Score)



// WEBPACK FOOTER //
// ./src/components/Score/index.js